<div class="head-count">
  <div class="styled-container">
    <div class="row-container">
      <div class="col">
        <emerald-card >
          <div class="content-container">
            <div class="header-row">
              <div class="heading-title">{{ vendorProfile.interviewStatus }}</div>
              <div class="filter">
                <emerald-dropdown
                  [options]="monthOptions"
                  [outlined]="true"
                  [id]="'single_select'"
                  [label]="'Month'"
                  (onChange)="onMonthChange($event)"
                ></emerald-dropdown>
              </div>
            </div>
          </div>

          <div class="metrics">
            <div class="metric" *ngFor="let metric of metrics">
              <span class="label">{{ interviewStatus[metric.key] }}</span>
              <span class="value">{{ data?.[metric.key] || '0' }}</span>
            </div>
          </div>
        </emerald-card>
      </div>
    </div>
  </div>
</div>
